import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

const Label = styled.span`
  ${({
    theme: {
      typography: {
        catchword: {
          small2: { bundledCSS: catchwordSmall2CSS },
        },
      },
      spacing: { spacing4, spacing8, spacing16 },
      colors: { fillBrand, staticWhite },
    },
  }) => css`
    ${catchwordSmall2CSS};
    text-transform: uppercase;

    padding: ${spacing4};
    background-color: ${fillBrand};
    color: ${staticWhite};

    margin-right: ${spacing8};
    vertical-align: top;
    line-height: ${19 * 1.2}px;

    ${desktopCSS(css`
      margin-right: ${spacing16};
      line-height: ${22 * 1.2}px;
    `)}
  `}
`

export default Label
